import React, {Component} from 'react';
import { Form, Input, Modal, Button, Row, Col } from 'antd'
import { gql, graphql, compose } from 'react-apollo'
import Thank from './Thanks'
import './style.css'
const FormItem = Form.Item
const confirm = Modal.confirm

class Submission extends Component {
    constructor(props){
        super(props)
        this.state = {
            bib: '' ,
            name: this.props.facebook.name,
            visible: false,
            finish: false
        }
    }
    handleCancel = (e) => {
        this.setState({
            visible: false
        })
    }
    handleOk = () => {
        this.props.form.validateFields((err, value) => {
            if(!err) {
                const { event } = this.props
                    this.props.createToken ({
                        variables: {
                            bib: value.bib ,
                            slug: event.slug ,
                            userId: this.props.facebook.userID,
                            accessToken: this.props.facebook.accessToken, //longToken.access_token //this.props.facebook.accessToken
                            name: this.props.facebook.name
                        }
                    }).then(res => {
                        console.log(res.data.facebook)
                        /* Modal.success({
                            title: 'Success' ,
                            content: 'Registration success'
                        }) */
                        this.setState({
                            bib: value.bib,
                            finish: true
                        })
                        
                    }).catch((err) => {
                        console.error(err)
                        Modal.error({
                            title: 'Invalid value',
                            content: `Please input number`
                        })
                    })
                // })
            }
        }) 
    }
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields((err, value) => {
            if(!err) {
                var ok = this.handleOk
                confirm({
                    title: 'Confirm information',
                    content: `Name: ${this.state.name} Bib: ${value.bib}`,
                    onOk(){
                        ok()
                    },
                    onCancel() {
                        console.log('Cancel')
                    }
                })
                
            }
        })
    }
    
    /* onChange = (e) => {
        const { value } = e.target;
        const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
        if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
            this.props.Change(value);
        }
    } */
    
    render() {
        const { getFieldDecorator } = this.props.form
        if(this.state.finish) {
            return <Thank name={this.state.name} bib={this.state.bib} event={this.props.event}/>
        }
        return (
            <div>
                <Row>
                    <Col span={24} style={{textAlign: "center"}}>
                        <div className="label-header">
                            <h2 className="name-facebooK"> Hi, {this.state.name}</h2>
                            <p className="head-submission">Please enter your bib number</p>
                        </div>
                        <Form onSubmit={this.handleSubmit}>
                            <FormItem>
                                {getFieldDecorator('bib',{
                                    rules: [{ required: true, message: 'Please input your bib!'}]
                                })(
                                    <Input 
                                        placeholder="bib number" style={{width: "200px"}}
                                    />
                                )}
                            </FormItem>
                            <FormItem>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Confirm
                                </Button>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
                {/*  <Modal 
                    title="Confirm your information"
                    visible={this.state.visible}
                    onOk={this.handleOK}
                    onCancel={this.handleCancel}
                >
                    <h2>Bib: <span style={{fontWeight: "normal"}}>{this.state.bib}</span></h2>
                </Modal>  */}
            </div>
        );
    }
}

/* const updateAccessToken = gql`
mutation updateToken($bib: Float, $name: String, $lastName: String $event: String, $accessToken: String){
  runnerUpdateOne(
    filter: {
      bib: $bib,
      name: $name,
      lastName: $lastName
      event:$event
    },
    record: {
      accessToken: $accessToken
    }
  ){
    record {
      bib
      name
      lastName
      nameOnBib
      race
      birthDate
      gender
      email
      phone
      group
      club
      event
      year
      accessToken
      _id
    }
  }
}
` */
const createAccessToken = gql`
mutation createToken($bib: Int!, $slug: String!, $userId: String!, $accessToken: String!, $name: String!){
  facebook(
    recode: {
        bib: $bib,
        slug:$slug
        userId: $userId
        accessToken: $accessToken
        name: $name
    }
  ){
        bib
        slug
        name
        userId
        accessToken
  }
}
`

export default compose(
    Form.create(),
    graphql(createAccessToken, {
        name: 'createToken'
    }),
)(Submission)

// export default Form.create()(SubmissionWithMutate)



// WEBPACK FOOTER //
// ./src/Login/Submission.js